import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getFundList = async (params) => await api.get("/v1/funds", { params });

export const getFundById = async (id) => await api.get(`/v1/funds/${id}`);

export const createFund = async (payload) => {
    return await api.post("/v1/funds", payload);
}

export const updateFund = async (id, payload) => {
    return await api.put(`/v1/funds/${id}`, payload)
};

export const deleteFund = async (id) => await api.delete(`/v1/funds/${id}`);


export const getPositionList = async (params = {}) => {
    return await api.post("/v1/dropdown/getPosition", params);
};
